import { AtomChannels, AtomTopics } from '@client/core/atoms/consts.js';
import { atom } from '@podium/store';
import type { PrebidKeyValue } from '@schibsted-nmp/advertising-shared';

export const $prebidTargetingAtom = atom<$prebidTargetingAtom.Value>(
  AtomChannels.Podlet,
  AtomTopics.PrebidTargeting,
  []
);

export namespace $prebidTargetingAtom {
  export type Value = Array<PrebidKeyValue>;
}

function normalizePrebidTargeting(prebidTargeting: Array<PrebidKeyValue>) {
  const targetingMap: Record<string, string[]> = {};

  for (const { key, value } of prebidTargeting) {
    const existing = targetingMap[key] ?? [];
    targetingMap[key] = Array.from(new Set([...existing, ...value]));
  }

  return Object.entries(targetingMap).map(([key, value]) => ({
    key,
    value
  }));
}

/**
 * Updates the global targeting state with new key-value pairs for Prebid.
 *
 * The function merges the current targeting state with the new targeting values, ensuring:
 * - Keys are unique in the final state.
 * - If a key already exists, its values are merged with the new values.
 * - Duplicate values for the same key are removed.
 *
 * @param prebidTargeting - An array of PrebidKeyValue objects to add to the global targeting state.
 */
export function setPrebidTargetingAtom(prebidTargeting: Array<PrebidKeyValue>) {
  const currentTargeting = $prebidTargetingAtom.value ?? [];
  const combinedTargeting = [...currentTargeting, ...prebidTargeting];

  $prebidTargetingAtom.set(normalizePrebidTargeting(combinedTargeting));
}

export function replacePrebidTargetingAtom(
  prebidTargeting: Array<PrebidKeyValue>
) {
  $prebidTargetingAtom.set(normalizePrebidTargeting(prebidTargeting));
}
